import { Text, View } from '@react-pdf/renderer'
import { IInvoiceFr } from '../../../types/invoice-fr'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const InvoiceDetails = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  const { t } = useTranslation()

  return (
    <View style={[styles.sectionContainer, styles.mYmediumContainer]}>
      <Text style={styles.sectionHeader}>
        {t('sharedDiagnostic.invoice.details')}
      </Text>
      <View style={styles.divider} />
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.headerRow]}>
          <Text style={[styles.tableCell, styles.headerCell]}>
            {t('sharedDiagnostic.invoice.designation')}
          </Text>
          <Text style={[styles.tableCell, styles.headerCell]}>
            {t('sharedDiagnostic.invoice.code')}
          </Text>
          <Text
            style={[styles.tableCell, styles.headerCell, styles.amountCell]}
          >
            {t('sharedDiagnostic.invoice.amount')}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tableCell}>
            {t('sharedDiagnostic.invoice.request')}
          </Text>
          <Text style={styles.tableCell}>{invoiceData.code}</Text>
          <Text style={[styles.tableCell, styles.amountCell]}>
            {invoiceData.amountInEur} €
          </Text>
        </View>
        <View style={[styles.tableRow, styles.totalRow]}>
          <Text style={[styles.tableCell, styles.headerCell]}>Total</Text>
          <Text style={styles.tableCell}></Text>
          <Text
            style={[styles.tableCell, styles.amountCell, styles.headerCell]}
          >
            {invoiceData.amountInEur} €
          </Text>
        </View>
      </View>
    </View>
  )
}

export default InvoiceDetails
